module.exports = __webpack_public_path__ + "static/sessionRecordings-b04b3db090b4804f3bc43e9424fb77ba.png";